import React from 'react'
import { Box, Text } from 'grommet'
// import styled from 'styled-components'
import InputButton from '../Button/InputButton'

const ResultType = ({ typeOption, setTypeOption }) => {
  // const typeOptionsArray = [0, 1, 2, 3, 4]
  return (
    <Box margin={{ top: '0rem' }} gap=".5rem">
      <Text>Mode: </Text>
      <Box direction="row" gap="1rem" justify="center">
        <InputButton active={typeOption === 0} onClick={() => setTypeOption(0)}>
          Random Number
        </InputButton>
        <InputButton active={typeOption > 0} onClick={() => setTypeOption(1)}>
          Random Digits
        </InputButton>
        {/* {typeOptionsArray.map(typeOption => {
          return (
            <Type
              key={`typeOption${typeOption}rng`}
              typeOption={typeOption}
              onOptionSelect={setTypeOption}
              optionSelected={optionIndex}
            ></Type>
          )
        })} */}
      </Box>
    </Box>
  )
}

export default ResultType
